<template>
  <div class="tabbar flex-center">
    <div v-for="(item, index) of list" :key="index" @click="go(item.name)">
      <img :src="item.active" alt="" style="height: 0.3rem" v-if="active === item.name"/>
      <img :src="item.icon" alt="" style="height: 0.3rem" v-else/>
      <div class="tabbar-text" :style="active === item.name?`color:#763a27;`:``">{{ item.title }}</div>
    </div>
  </div>
</template>

<script>
import bottom1 from '@/assets/mobile/bottom1.png'
import bottom2 from '@/assets/mobile/bottom2.png'
import bottom3 from '@/assets/mobile/bottom3.png'
import bottom4 from '@/assets/mobile/bottom4.png'
import bottom5 from '@/assets/mobile/bottom5.png'
import bottom6 from '@/assets/mobile/bottom6.png'
import bottom11 from '@/assets/mobile/bottom1-1.png'
import bottom21 from '@/assets/mobile/bottom2-1.png'
import bottom31 from '@/assets/mobile/bottom3-1.png'
import bottom41 from '@/assets/mobile/bottom4-1.png'
import bottom51 from '@/assets/mobile/bottom5-1.png'
import bottom61 from '@/assets/mobile/bottom6-1.png'
import $ from 'jquery'
export default {
  name: "tabbar",
  props:{
      'active':{
          type:String,
          default:''
      }
  },
  data() {
    return {
      list: [
        {
          name: "home",
          title: "医院首页",
          icon: bottom1,
          active: bottom11,
        },
        {
          name: "about",
          title: "医院介绍",
          icon: bottom2,
          active: bottom21,
        },
        {
          name: "characteristic",
          title: "特色医疗",
          icon: bottom3,
          active: bottom31,
        },
        {
          name: "medicalRecord",
          title: "病历简介",
          icon: bottom4,
          active: bottom41,
        },
        {
          name: "news",
          title: "医院资讯",
          icon: bottom5,
          active: bottom51,
        },
        {
          name: "contact",
          title: "联系我们",
          icon: bottom6,
          active: bottom61,
        },
      ],
    };
  },
  methods: {
    go(name) {
      this.$router.push({ name }).catch(() => {
          this.backtopClick()
      });
    },
    backtopClick() {
      $('body,html').animate({scrollTop:0},1000);
      return false;
    },
  },
};
</script>

<style>
.tabbar {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e5e5e5;
  background: #439392;
}
.tabbar > div {
  flex: 1;
  text-align: center;
  margin: 0.05rem 0;
  transform: scale(0.9);
}
.tabbar .tabbar-text {
  font-size: 0.1rem;
  color: #fff;
  margin-top:0.05rem;
}
</style>


// WEBPACK FOOTER //
// src/components/bottomBar.vue